import { css } from '@emotion/react'

const S = {
  basic: css`
    display: flex;
    align-items: center;
    line-height: 22px;
    > img {
      cursor: pointer;
    }
  `,
  text: css`
    text-decoration: underline;
  `,
  iconButton: css`
    display: inline-flex;
    align-items: center;
    padding: 0;
    border: none;
    background: none;
    cursor: pointer;
  `,
}

export default S
